import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class DemoLoginTokenService {

  private decodeJwtPayload(token: string): Record<string, unknown> | null {
    try {
      const payload = token.split('.')[1];
      if (!payload) {
        return null;
      }

      const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
      const paddedPayload = normalizedPayload.padEnd(
        normalizedPayload.length + (4 - (normalizedPayload.length % 4)) % 4,
        '='
      );

      const json = decodeURIComponent(
        atob(paddedPayload)
          .split('')
          .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
          .join('')
      );

      return JSON.parse(json) as Record<string, unknown>;
    } catch {
      return null;
    }
  }

  // Removes any access token left over from a previous session before a new
  // demo login attempt, so the global OAuth interceptor doesn't attach a
  // stale/expired Authorization header to the (unauthenticated) login call.
  clearAccessToken(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token_claims_obj');
  }

  persistAccessToken(accessToken: string): boolean {
    if (typeof accessToken !== 'string' || !accessToken.trim()) {
      return false;
    }

    try {
      localStorage.setItem('access_token', accessToken);
      const claims = this.decodeJwtPayload(accessToken);
      if (claims?.['sub']) {
        localStorage.setItem('id_token_claims_obj', JSON.stringify(claims));
      }

      return true;
    } catch {
      return false;
    }
  }

  // sessionStorage on purpose: survives a reload within the same tab (needed
  // to free the showcase after a kiosk refresh) but is discarded when the
  // tab/browser closes, so it never lingers longer than the current visit.
  persistShowcaseId(showcaseId: string): void {
    sessionStorage.setItem('demo_showcase_id', showcaseId);
  }

  getShowcaseId(): string | null {
    return sessionStorage.getItem('demo_showcase_id');
  }

  clearShowcaseId(): void {
    sessionStorage.removeItem('demo_showcase_id');
  }
}
